<template>
  <div class="cui-users__main-container profile">
    <v-tabs v-model="tab" class="line-wrap pb-6">
      <v-tab href="#org-profile"> Organization Profile </v-tab>
      <v-divider inset vertical></v-divider>
      <v-tab
        href="#directory"
        v-if="getUserData.roleList.includes('Security Administrator')"
        @click="getDirectoryList()"
      >
        Directory
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        value="org-profile"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-card flat>
          <h5 class="pb-6 font-weight-bold ft-175" v-if="getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO'">{{getUserData.user.realm}}</h5>
          <h5 class="pb-6 font-weight-bold ft-175" v-else>AMTB-{{getUserData.organization.attributes.find(item=> item.name == 'homeLocation').value}}</h5>
          <h6 class="font-weight-bold pb-2">Security Administrators</h6>
          <v-row>
            <v-col cols="6">
              <div
                class="pb-3"
                v-for="(profile, index) in securityOrgProfiles"
                :key="index"
              >
                <h6 class="font-weight-bold">
                  Name:
                  <span class="font-weight-medium"
                    >{{ profile.name.given }} {{ profile.name.surname }}</span
                  >
                </h6>
                <h6 class="font-weight-bold">
                  Username:
                  <span class="font-weight-medium">{{ profile.username }}</span>
                </h6>
                <h6 class="font-weight-bold">
                  Title:
                  <span class="font-weight-medium">{{ profile.title }}</span>
                </h6>
                <h6 class="font-weight-bold">
                  Phone:
                  <span class="font-weight-medium">{{
                    profile.phones | getNumber("main")
                  }}</span>
                </h6>
                <h6 class="font-weight-bold pb-3">
                  Email:
                  <span class="font-weight-medium">{{ profile.email }}</span>
                </h6>
                <hr />
              </div>
            </v-col>
            <v-col cols="6">
              <div class="pb-3">
                <h6 class="font-weight-bold">Address:</h6>
                <div
                  v-for="(address, index) in getUserData.user.addresses"
                  :key="index"
                >
                  <h6
                    class="mb-0"
                    v-for="(street, i) in address.streets"
                    :key="i"
                  >
                    <span>{{ street }}</span>
                  </h6>
                  <h6 class="mb-0">
                    <span>{{ address.city }}</span>
                  </h6>
                  <h6 class="mb-0">
                    <span
                      >{{ address.state }}, {{ address.postal }} -
                      {{ address.country | getCountryName }}</span
                    >
                  </h6>
                </div>
              </div>
              <hr />
              <div class="py-3">
                <h6 class="font-weight-bold">
                  Url:
                  <a
                    href="http://www.covisint.com"
                    target="_blank"
                    class="font-weight-medium black--text text-decoration-none"
                    >http://www.covisint.com</a
                  >
                </h6>
                <h6 class="font-weight-bold">Password Policy:</h6>
                <h6>
                  <span class="font-weight-medium">{{ passwordPolicies }}</span>
                </h6>
                <h6 class="font-weight-bold">Authentication Policy:</h6>
                <h6>
                  <span class="font-weight-medium">{{ authPolicy }}</span>
                </h6>
              </div>
              <hr />
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <v-tab-item
        value="directory"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-card v-if="ditectoryTab">
          <v-card-title>
            <h6 class="font-weight-bold">{{getUserData.user.realm}}</h6>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="nameFilter"
              label="Search"
              outlined
              dense
              hide-details
              @keydown.enter="filterPersonsData()"
            ></v-text-field>
            <v-btn
              outlined
              depressed
              style="
                height: 41px;
                background: rgb(0, 120, 124);
                margin-left: -4px;
              "
              medium
              class="white--text"
              @click="filterPersonsData()"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div class="text-center">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                  >
                    <v-icon>mdi-filter</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item-group v-model="statusFilter">
                    <v-list-item v-for="(item, index) in filter1" :key="index">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn depressed outlined v-bind="attrs" v-on="on">
                    <v-icon>mdi-sort-alphabetical-variant</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item-group v-model="sortFilter">
                    <v-list-item v-for="(item, index) in filter2" :key="index">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="personsDataItems"
            :search="search"
            class="directory-table"
          >
            <template v-slot:[`item.name`]="{ item }">
              <div @click="directoryUserDetails(item)" class="cursor">
                <v-avatar
                  color="#00667c"
                  class="text-center"
                  style="width: 48px; height: 48px"
                >
                  <span style="font-size: 1.3em; color: white"
                    >{{ item.name.given | firstChar
                    }}{{ item.name.surname | firstChar }}
                  </span>
                </v-avatar>
                <span grey class="font-weight-bold ml-6" style="color: #4a4a4a">
                  {{ item.name.given }} {{ item.name.surname }}</span
                >
              </div>
            </template>
            <template v-slot:[`item.uname`]="{ item }">
              <div
                grey
                class="font-weight-medium"
                style="color: #4a4a4a; letter-spacing: 1.6px"
              >
                {{ item.username }}
              </div>
            </template>
            <template v-slot:[`item.ustatus`]="{ item }">
              <div
                grey
                class="font-weight-medium"
                style="color: #4a4a4a; letter-spacing: 1.6px"
              >
                {{ item.status }}
              </div>
            </template>
          </v-data-table>
        </v-card>
        <div v-else>
          <div class="bg-grey py-6">
            <div
              grey
              class="font-weight-bold cursor"
              style="color: #4a4a4a; letter-spacing: 1.6px"
              @click="directoryUserDetails"
            >
              <v-icon>mdi-keyboard-backspace</v-icon>
              Back
            </div>
            <div class="text-center py-4">
              <v-avatar
                color="#00667c"
                class="text-center"
                style="width: 4.375em; height: 4.375em"
              >
                <span style="font-size: 1.3em; color: white"
                  >{{ updateDirectoryUserDetails.name.given | firstChar
                  }}{{
                    updateDirectoryUserDetails.name.surname | firstChar
                  }}</span
                >
              </v-avatar>
              <div
                class="font-weight-bold"
                style="font-size: 1.325em; letter-spacing: 1.8px; color: #000"
              >
                {{ updateDirectoryUserDetails.name.given }}
                {{ updateDirectoryUserDetails.name.surname }}
              </div>
              <div
                grey
                class="font-weight-bold"
                style="color: #4a4a4a; letter-spacing: 1.6px"
              >
                User ID: {{ updateDirectoryUserDetails.username }}
              </div>
              <div
                grey
                class="font-weight-medium"
                style="color: #4a4a4a; letter-spacing: 1.6px"
              >
                Registered:
                {{
                  updateDirectoryUserDetails.activatedDate
                    | formatDate(getUserData.user.timezone)
                }}
              </div>
              <div
                grey
                class="font-weight-bold"
                style="color: #4a4a4a; letter-spacing: 1.6px"
              >
                Status: {{ updateDirectoryUserDetails.status }}
              </div>
            </div>
          </div>
          <directoryTabs :personID="updateDirectoryUserDetails.id" />
          <v-row class="bg-grey py-6">
            <v-col cols="5">
              <v-tabs
                v-model="directorytab"
                centered
                icons-and-text
                class="d-flex"
              >
                <v-tab href="#profile" class="tab-clr">
                  PROFILE
                  <v-icon>mdi-account-circle-outline</v-icon>
                </v-tab>
                <v-tab href="#roles" class="tab-clr">
                  ROLES
                  <v-icon>mdi-svg</v-icon>
                </v-tab>
              </v-tabs>
              <v-divider></v-divider>
              <v-tabs-items v-model="directorytab">
                <v-tab-item
                  value="profile"
                  transition="fade-transition"
                  reverse-transition="fade-transition"
                >
                  <v-card flat class="px-6">
                    <v-row class="pt-4">
                      <div class="w-100">
                        <div v-if="!isShow.information">
                          <h6 class="font-weight-bold pb-2">
                            Basic Information
                            <v-btn
                              class="float-right"
                              text
                              @click="updateDetails('information', true)"
                            >
                              Edit
                            </v-btn>
                          </h6>
                          <h6 class="font-weight-bold">
                            Name:
                            <span class="font-weight-medium"
                              >{{ updateDirectoryUserDetails.name.given }}
                              {{
                                updateDirectoryUserDetails.name.surname
                              }}</span
                            >
                          </h6>
                          <h6 class="font-weight-bold">
                            Email:
                            <span class="font-weight-medium">{{
                              updateDirectoryUserDetails.email
                            }}</span>
                          </h6>
                        </div>
                        <div class="update-form pa-8" v-else>
                          <h6 class="font-weight-bold pb-4">
                            Basic Information
                            <span class="float-right font-weight-medium">
                              <v-icon
                                @click="updateDetails('information', false)"
                                >mdi-close-circle</v-icon
                              >
                            </span>
                          </h6>
                          <div class="py-2">
                            <h4 class="pb-2 grey--text">First Name</h4>
                            <v-text-field
                              v-model="editProfile.name.given"
                              outlined
                              dense
                            ></v-text-field>
                          </div>
                          <div class="py-2">
                            <h4 class="pb-2 grey--text">Last Name</h4>
                            <v-text-field
                              v-model="editProfile.name.surname"
                              outlined
                              dense
                            ></v-text-field>
                          </div>
                          <div class="py-2">
                            <h4 class="pb-2 grey--text">Email</h4>
                            <v-text-field
                              v-model="editProfile.email"
                              outlined
                              dense
                            ></v-text-field>
                          </div>
                          <div class="mt-2 text-right">
                            <v-btn
                              depressed
                              medium
                              class="mr-1"
                              @click="updateDetails('information', false)"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              depressed
                              medium
                              color="rgb(0, 102, 124)"
                              class="white--text"
                              @click="updateProfile(editProfile.id)"
                            >
                              Update
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div class="w-100 py-3">
                        <div v-if="!isShow.password">
                          <h6 class="font-weight-bold pt-4">
                            Password:
                            <span class="font-weight-medium"> **********</span>
                            <span class="float-right font-weight-medium">
                              <v-btn
                                text
                                @click="updateDetails('password', true)"
                              >
                                Edit
                              </v-btn>
                            </span>
                          </h6>
                        </div>
                        <div class="update-form pa-8 my-3 pwd-form" v-else>
                          <h6 class="font-weight-bold pb-4">
                            Password
                            <span class="float-right font-weight-medium">
                              <v-icon @click="updateDetails('password', false)"
                                >mdi-close-circle</v-icon
                              >
                            </span>
                          </h6>
                          <v-form ref="form" v-model="valid">
                            <div class="py-2">
                              <h4 class="pb-2 grey--text">Current Password</h4>
                              <v-text-field
                                v-model="currentPwd"
                                outlined
                                dense
                                type="password"
                                required
                              ></v-text-field>
                            </div>
                            <div class="py-2">
                              <h4 class="pb-2 grey--text">
                                Enter new password
                              </h4>
                              <v-text-field
                                v-model="pw1"
                                outlined
                                dense
                                type="password"
                                :rules="pwdRules"
                                :class="validationRes.valid == false ? 'error--text validatepwd' : 'validatepwd'"
                              ></v-text-field>
                              <p v-if="(validationRes.errors.length > 0) || (validationRes.valid == false)" class="error--text error-msg">{{messageValidationerror}}</p>
                            </div>
                            <div class="py-2">
                              <h4 class="pb-2 grey--text">
                                Re-enter new password
                              </h4>
                              <v-text-field
                                v-model="pw2"
                                outlined
                                dense
                                type="password"
                                :rules="pwdConfirm"
                              ></v-text-field>
                            </div>
                            <div class="mt-2 text-right">
                              <v-btn
                                depressed
                                medium
                                class="mr-1"
                                @click="updateDetails('password', false)"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                depressed
                                medium
                                color="rgb(0, 102, 124)"
                                class="white--text"
                                @click="updatePassword()"
                                :disabled="!valid"
                              >
                                Update
                              </v-btn>
                            </div>
                          </v-form>
                        </div>
                      </div>
                    </v-row>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  value="roles"
                  transition="fade-transition"
                  reverse-transition="fade-transition"
                >
                  <v-card flat class="px-6">
                    <v-row class="pt-4">
                      <div class="w-100 mb-4">
                        <h6 class="font-weight-bold pb-2">Assigned Roles</h6>
                        <v-data-table
                          style="background: rgb(249, 249, 249)"
                          v-model="assRoles"
                          :headers="rolesHeaders"
                          :items="detailsPersonRoles"
                          item-key="name"
                          show-select
                          :hide-default-header="true"
                          :hide-default-footer="true"
                          class="elevation-0 font-weight-bold roles-assign"
                        >
                        </v-data-table>
                        <v-divider></v-divider>
                        <v-btn
                          depressed
                          large
                          color="rgb(0, 102, 124)"
                          style="text-transform: capitalize"
                          class="white--text my-5 mx-1"
                          @click="removeAssignRoles(updateDirectoryUserDetails.id)"
                          :disabled="!assRoles.length > 0"
                        >
                          Remove Roles
                        </v-btn>
                      </div>
                      <div class="w-100">
                        <h6 class="font-weight-bold pb-2">Available Roles</h6>
                        <v-data-table
                          style="background: rgb(249, 249, 249)"
                          v-model="availRoles"
                          :headers="rolesHeaders"
                          :items="detailsPersonAllRoles"
                          item-key="name"
                          show-select
                          :hide-default-header="true"
                          :hide-default-footer="true"
                          class="elevation-0 font-weight-bold roles-assign"
                        >
                        </v-data-table>
                        <v-divider></v-divider>
                        <v-btn
                          depressed
                          large
                          color="rgb(0, 102, 124)"
                          style="text-transform: capitalize"
                          class="white--text my-5 mx-1"
                          @click="assignRoles(updateDirectoryUserDetails.id)"
                          :disabled="!availRoles.length > 0"
                        >
                          Assign Roles
                        </v-btn>
                      </div>
                    </v-row>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
            <v-col cols="2"> </v-col>
            <v-col cols="5">
              <v-tabs
                v-model="directorytab2"
                centered
                icons-and-text
                class="d-flex"
              >
                <v-tab
                  href="#history"
                  class="tab-clr"
                  @click="getPasswordChangeHistory()"
                >
                  HISTORY
                  <v-icon>mdi-clock-check-outline</v-icon>
                </v-tab>
              </v-tabs>
              <v-divider></v-divider>
              <v-tabs-items v-model="directorytab2">
                <v-tab-item
                  value="history"
                  transition="fade-transition"
                  reverse-transition="fade-transition"
                >
                  <v-card flat class="px-6">
                    <v-row class="my-0">
                      <div>
                        <h6 class="font-weight-bold pb-2">Status History</h6>
                        <v-divider></v-divider>
                        <h6 class="font-weight-bold mb-4 mt-2">
                          Last Login:
                          <span class="font-weight-medium">{{
                            updateDirectoryUserDetails.lastLoginDate
                              | formatDate(getUserData.user.timezone)
                          }}</span>
                        </h6>
                        <h6 class="font-weight-bold">
                          active:
                          <span class="font-weight-medium">{{
                            updateDirectoryUserDetails.activatedDate
                              | formatDate(getUserData.user.timezone)
                          }}</span>
                        </h6>
                        <h6 class="font-weight-bold">
                          pending:
                          <span class="font-weight-medium">{{
                            updateDirectoryUserDetails.activatedDate
                              | formatDate(getUserData.user.timezone)
                          }}</span>
                        </h6>
                      </div>
                    </v-row>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <v-snackbar
      :timeout="5000"
      :value="profileUpdatedFlage"
      color="rgb(0, 102, 124)"
      absolute
      top
    >
      Updated Profile successfully
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable */
// eslint-disable-next-line
import Countries from "@/plugins/factory/Countries";
import Timezones from "@/plugins/factory/Timezones";
import { languages } from "@/plugins/factory/Language";
import _ from "lodash";
import directoryTabs from "@/components/partials/directoryTabs";

export default {
  mounted() {
    let vm = this;
    setTimeout(() => {
      vm.$store.dispatch("getSecurityOrgProfiles");
      vm.$store.dispatch("getPasswordPolicies");
      vm.$store.dispatch("getAuthPolicy");
    }, 1000);
  },
  components: {
    directoryTabs,
  },
  data() {
    return {
      search: "",
      mask: true,
      tab: null,
      assRoles: [],
      availRoles: [],
      rolesHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
      ],
      directorytab: null,
      directorytab2: null,
      suspend: false,
      isShow: {
        information: false,
        password: false,
        addressUpdate: false,
        questionsUpdate: false,
        contactUpdate: false,
        timezoneUpdate: false,
      },
      isUpdate: false,
      ditectoryTab: true,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      editProfile: {},
      challengeQuestionSet: [],
      timeZonesList: Timezones.timezones,
      languagesList: languages,
      currentPwd: "",
      pw1: "",
      pw2: "",
      statusFilter: 0,
      sortFilter: null,
      nameFilter: "",
      pwdConfirm: [
        (v) => !!v || "Confirm password",
        (v) => v === this.pw1 || "Passwords do not match",
      ],
      valid: true,
      historyHeaders: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "creation",
        },
        {
          text: "Event Type",
          align: "start",
          sortable: false,
          value: "eventType",
        },
        {
          text: "Action Performed by",
          align: "start",
          sortable: false,
          value: "passwordUpdatedUserId",
        },
        {
          text: "Notes",
          align: "start",
          sortable: false,
          value: "notes",
        },
      ],
      filter1: [
        { title: "All" },
        { title: "Active" },
        { title: "Pending" },
        { title: "Locked" },
        { title: "Suspended" },
      ],
      filter2: [{ title: "Alphabetical" }, { title: "Date Added" }],
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "User Name",
          align: "start",
          value: "uname",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",  
          value: "ustatus",
          sortable: false,
        },
      ],
      directoryDetails: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
        },
      ],
      rules: [],
      requiredNumberOfCharClasses: 1,
      messageValidationerror: null,
      minLength: 8,
      validationRes: { valid:true, errors:[] },
      lengthCondition: {}
    };
  },
  computed: {
    getUserData() {
      return this.$store.getters.getUserInfo;
    },
    profileUpdatedFlage() {
      return this.$store.getters.getProfileUpdatedFlage;
    },
    pwdChangeHistory() {
      return this.$store.getters.getPwdChangeHistory;
    },
    securityOrgProfiles() {
      return this.$store.getters.getSecurityOrgProfiles;
    },
    passwordPolicies() {
      return this.$store.getters.getPasswordPolicies;
    },
    authPolicy() {
      return this.$store.getters.getAuthPolicy;
    },
    personsDataItems() {
      return this.$store.getters.getPersonsData;
    },
    detailsPersonRoles() {
      return this.$store.getters.getPersonRoles.filter((item)=> {
          if(["Security Administrator", "Maintenance User", "Materials Manager"].includes(item.name)){
             return true
          }
       })
    },
    detailsPersonAllRoles() {
      return this.$store.getters.getPersonAllRoles;
    },
    updateDirectoryUserDetails() {
      return this.$store.getters.getDetailsPerson;
    },
    updateDetailsPasword() {
      return this.$store.getters.getPassword;
    },
      passwordRules () {
        return this.$store.getters.getPwdRules
      },
    pwdRules() {
      if (this.$store.getters.getPwdRules.length > 0) {
        this.rules = [];
        const passwordRulesList = this.$store.getters.getPwdRules[0];
        const passwordLength = this.$store.getters.getPwdRules[1].min;
        this.requiredNumberOfCharClasses = passwordRulesList.requiredNumberOfCharClasses;
        this.minLength = this.$store.getters.getPwdRules[1].min;

        if(passwordRulesList.allowUpperChars) {
          this.rules.push({ message:"One uppercase letter required.",  regex:/[A-Z]+/ })
        }
         if(passwordRulesList.allowLowerChars) {
          this.rules.push({ message:'One lowercase letter required.', regex:/[a-z]+/ })
        }
        if(passwordRulesList.allowNumChars) {
          this.rules.push({ message:"One number required.", regex:/[0-9]+/ })
        }
        if(passwordRulesList.allowSpecialChars) {
          this.rules.push({ message:"secial characters minimum.", regex:/[!#$%&'*+/=@]+/ })
        }
        if (
          passwordRulesList.allowUpperChars &&
          passwordRulesList.allowLowerChars &&
          passwordRulesList.allowNumChars &&
          passwordRulesList.allowSpecialChars
        ) {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Number, Lower Case Letters, Upper Case Letters, special symbol(ex: !,*,+)`
          
          } else if (
          passwordRulesList.allowUpperChars &&
          passwordRulesList.allowLowerChars &&
          passwordRulesList.allowNumChars &&
          !passwordRulesList.allowSpecialChars
        ) {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Number, Lower Case Letters, Upper Case Letters`
          
        } else {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Lower Case Letters, Upper Case Letters`;
         
        }
        return [
          v => (v && v.length >= this.minLength) || `Password must be greater than ${passwordLength} characters.`
        ]
      }else {
        return []
      }
    },
  },
  methods: {
    updateDetails(key, flag) {
      this.editProfile = Object.assign({}, this.updateDirectoryUserDetails);
      this.currentPwd = "";
      this.pw1 = "";
      this.pw2 = "";
      this.isShow = _.mapValues(this.isShow, () => false);
      this.isShow[key] = flag;
    },
    updateProfile() {
      var payload = {
        id: this.editProfile.id,
        user: this.editProfile,
      };
      this.$store.dispatch("UpdateUserProfile", payload);
    },
    setUserDetails(newValue, mainProperty, findKey, findValue, updateKey) {
      this.editProfile[mainProperty].forEach((element) => {
        if (element[findKey] == findValue) {
          element[updateKey] = newValue;
        }
      });
    },
    updatePassword() {
      const pwdParams = {
        version: "1",
        username: this.updateDirectoryUserDetails.username,
        currentPassword: this.currentPwd,
        password: this.pw1,
        passwordPolicy: this.updateDetailsPasword.passwordPolicy,
        authenticationPolicy: this.updateDetailsPasword.authenticationPolicy,
      };
      this.$store.dispatch("updateUserPassword", {
        id: this.updateDirectoryUserDetails.id,
        pwdParams: pwdParams,
      });
    },
    getPasswordChangeHistory() {
      this.$store.dispatch(
        "getPasswordChangeHistory",
        this.getUserData.user.id
      );
    },
    directoryUserDetails(person) {
      if(person.id) {
        this.$store.dispatch("getOrganizationWithAttributes", person.organization.id);
        this.$store.dispatch("getPerson", person.id);
        this.$store.dispatch("getPersonRoles", person.id);
        this.$store.dispatch("getPersonPasswordOnly", person.id);
      }
      this.ditectoryTab = !this.ditectoryTab;
    },
    getDirectoryList() {
      this.$store.dispatch("getPersonsData", {
        pageSize: 200,
        orgId: this.getUserData.organization.id,
        "organization.id": this.getUserData.organization.id["id"],
      });
    },
    filterPersonsData() {
      var personPayload = {
        pageSize: 200,
        orgId: this.getUserData.organization.id,
        "organization.id": this.getUserData.organization.id["id"],
      };
      if (this.statusFilter != 0) {
        personPayload.status =
          this.filter1[this.statusFilter]["title"].toLowerCase();
      }
      if (this.nameFilter != "") {
        personPayload.fullName = this.nameFilter;
      }
      if (this.sortFilter != null) {
        personPayload.sortBy =
          this.sortFilter == 0 ? "+name.given" : "+activatedDate";
      }
      this.$store.dispatch("getPersonsData", personPayload);
    },
    removeAssignRoles (personId) {
       var rolesRemoveList = this.assRoles.map(function(item){
          return  Number(item.roleId)
       })
       var removePersonRolesPayload = {
          userId: personId,
          roleIds: rolesRemoveList
       }
       this.assRoles = [];
       this.$store.dispatch("removePersonRoles", removePersonRolesPayload);
    },
    assignRoles (personId) {
       var rolesAssignList = this.availRoles.map(function(item){
          return {
             id: item.roleId
          }
       })
       var assignPersonRolesPayload = {
          userId: personId,
          roles: rolesAssignList
       }
       this.availRoles = [];
       this.$store.dispatch("assignPersonRoles", assignPersonRolesPayload);
    }
  },
  watch: {
    pw1(val) {
      let errors = []
			for (let condition of this.rules) {
				if (!condition.regex.test(val)) {
					errors.push(condition.message)
				}
			}
			if ((this.rules.length - errors.length ) >= this.requiredNumberOfCharClasses) {
				this.validationRes = { valid:true, errors:[] }
			} else {
				this.validationRes = { valid:false, errors }
			}
    },
    profileUpdatedFlage(val) {
      if (val) {
        this.isShow = _.mapValues(this.isShow, () => false);
        let vm = this;
        setTimeout(function () {
          vm.$store.commit("SET_PROFILE_UPDATED_FLAG", false);
        }, 5000);
      }
    },
    statusFilter(val) {
      this.filterPersonsData();
    },
    sortFilter(val) {
      this.filterPersonsData();
    },
  },
  filters: {
    getNumber(phones, type) {
      return phones.find((item) => item.type === type)
        ? phones.find((item) => item.type === type).number
        : "";
    },
    getCountryName(code) {
      return Countries.getCountryByCode(code)
        ? Countries.getCountryByCode(code).name
        : "";
    },
    getTimezone(id) {
      return Timezones.getTimezoneById(id);
    },
    getlanguages(code) {
      return languages.find((item) => item.language === code)
        ? languages.find((item) => item.language === code).title
        : "";
    },
    getQuestionByID(qid, questions, languageCode) {
      const question = questions.find((item) => item.id === qid);
      if (question) {
        return question.question.find((q) => q.lang === languageCode)
          ? question.question.find((q) => q.lang === languageCode).text
          : "";
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.ft-175 {
  font-size: 1.75em;
}
.v-tabs:not(.v-tabs--vertical).line-wrap .v-tab {
  white-space: nowrap;
}
.roles-assign .v-data-table__wrapper table tbody tr td {
  font-size: 16px;
  color: #333;
  letter-spacing: 1px;
}
.bg-grey {
  background: #f9f9f9;
}
.directory-table tr td {
  height: 70px !important;
}
.v-application a.tab-clr {
  color: rgba(0, 0, 0, 0.25) !important;
  font-size: 11px;
  font-weight: 700;
}
.v-application
  .theme--light.v-tabs
  > .v-tabs-bar
  .v-tab:not(.v-tab--active)
  > .v-icon {
  color: rgba(0, 0, 0, 0.25) !important;
}
.v-application a.tab-clr.v-tab--active {
  color: #00667c !important;
}
.v-tabs-slider {
  color: #fff;
}
.profile .theme--light.v-tabs > .v-tabs-bar,
.profile .theme--light.v-card {
  background: #f9f9f9;
}
.profile h6 {
  color: #343534;
  letter-spacing: 1.6px;
  font-size: 1.25em;
}
.profile h6 span {
  color: #929292;
  font-size: 0.8em;
  letter-spacing: 1px;
}
.checklist .theme--light.v-label {
  color: #929292;
  font-size: 1em;
  letter-spacing: 1px;
}
.update-form {
  background: #d4e2e6;
}
.update-form .v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #fff;
}
.update-form .v-text-field__details {
  display: none;
}
.pwd-form .v-text-field__details{
  display:block !important;
  padding:0 !important
}
.pwd-form .v-text-field__details .v-messages__message{
  line-height:20px;
  font-size:14px
}
.border-none{
  border:none
}
.pwd-form .v-messages__message {
  padding:15px !important;
  border:1px solid #ccc;
  border-radius: 4px;
}
.validatepwd .v-messages__message {
  border: none !important;
}
.error-msg {
padding: 15px !important;
border-radius: 4px;
margin-bottom: 0 !important;
margin-top: -15px;
font-size: 14px !important;
text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/org.vue